import { DoubleMatchType } from "../../../helpers/Enums";
import NiceModal from "@ebay/nice-modal-react";
import usePrepareLink from "../../../hooks/usePrepareLink";
import { GET_PARAMS, GET_POPUPS } from "../../../const/router";
import { Link, useHistory, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { getCanMemberSendBounakir } from "../../../services/memberService";

const Button = ({
  bounakirMessage,
  doubleMatchType,
  memberImage,
  memberName,
  memberCode,
  userName,
}: any) => {
  const [navigateFromProfile, setNavigateFormProfile] =
    useState<boolean>(false);
  const location = useLocation();
  let history = useHistory();
  const memberObject = {
    bounakirMessage,
    doubleMatchType,
    memberImage,
    memberName,
    memberCode,
    userName,
  };

  const premiumMessagelink = usePrepareLink({
    pushToQuery: {
      [GET_PARAMS.popup]: GET_POPUPS.popup.premiumMessage,
    },
    keepOldQuery: true,
  });

  useEffect(() => {
    if (location && location.state) {
      const { navigateFromProfile }: any = location.state;
      setNavigateFormProfile(navigateFromProfile);
    }
  }, []);

  const profileLink = usePrepareLink({
    state: {
      navigateFromProfile: navigateFromProfile,
      memberName: memberName,
      userName: userName,
      memberImage: memberImage,
    },
    query: {
      [GET_PARAMS.memberCode]: memberCode,
    },
    pushToQuery: {
      [GET_PARAMS.popup]: GET_POPUPS.popup.chat,
    },
    keepOldQuery: true,
  });

  // const BounakirMessagelink = usePrepareLink({
  //     state: {
  //         member: JSON.stringify(memberObject),
  //     },
  //     query: {
  //         [GET_PARAMS.memberCode]: memberCode,
  //     },
  //     pushToQuery: {
  //         [GET_PARAMS.popup]: GET_POPUPS.popup.bounakirMessage,
  //     },
  //     keepOldQuery: true,
  // });

  const canMemberSendBounakir = async () => {
    const { data: canSend } = await getCanMemberSendBounakir();
    if (canSend) {
      openBounakirModal();
    } else {
      NiceModal.show("action_modal", {
        onNext: () => {
          NiceModal.hide("action_modal");
          history.push(premiumMessagelink);
        },
        // oncancel: () => { NiceModal.hide("action_modal"); },
        headerTitle: "כבר שלחת 5 הצעות היום",
        contentTitle:
          "המנוי שלך מאפשר שליחת 5 הצעות ביום, אפשר לחכות למחר או לשדרג לפרימיום כדי לשלוח הצעות ללא הגבלה ולהינות מעוד יתרונות",
        primaryButtonText: "שדרגו אותי לפרימיום",
        showCloseButton: true,
        showSeconderyButton: true,
        seconderyButtonText: "לא תודה",
      });

      // history.push(premiumMessagelink);
    }
  };

  const openBounakirModal = async () => {
    // console.log("openBounakirModal memberObject:", memberObject);

    NiceModal.show("bounkair_modal", {
      ...memberObject,
    });
  };

  const renderSwitch = () => {
    switch (doubleMatchType) {
      case DoubleMatchType.NoAction:
        return (
          <a
            onClick={canMemberSendBounakir}
            className="button_icon w-inline-block"
            style={{ cursor: "pointer" }}
          >
            <div> שליחת הצעת היכרות </div>
            {/* <div> שליחת הודעת פתיחה </div> */}

            <img
              src="assets/images/ic_shosh_white.svg"
              loading="lazy"
              alt=""
              className="ic_button"
            />
          </a>
        );
      case DoubleMatchType.SentMessage:
        return (
          <a
            onClick={openBounakirModal}
            className="button_icon w-inline-block"
            style={{ cursor: "pointer" }}
          >
            <div>בהמתנה לאישור היכרות</div>
            <img
              src="assets/images/ic_to.svg"
              loading="lazy"
              alt=""
              className="ic_button"
            />
          </a>
        );
      case DoubleMatchType.OtherSentMessage:
        return (
          <a
            onClick={openBounakirModal}
            className="button_icon w-inline-block"
            style={{ cursor: "pointer" }}
          >
            <div> רוצה להכיר אותך</div>
            <img
              src="assets/images/ic_from.svg"
              loading="lazy"
              alt=""
              className="ic_button"
            />
          </a>
        );
      case DoubleMatchType.DoubleMatch:
        return navigateFromProfile ? (
          <Link to={profileLink} className="button_icon w-inline-block">
            <div>שליחת הודעה</div>
            <img
              src="assets/images/ic_send.svg"
              loading="lazy"
              alt=""
              className="ic_button"
            />
          </Link>
        ) : (
          <a onClick={history.goBack} className="button_full mail w-button">
            {" "}
            שליחת הודעה{" "}
          </a>
        );
      default:
        return null;
    }
  };

  return (
    <div className="nav_sec full wf-section">
      <div className="content_block footer">{renderSwitch()}</div>
    </div>
  );
};

export default Button;
